import { useDayPriceStore } from "@/components/Inputs/RangePicker/stores/useDayPriceStore.ts";
import { useHoverStore } from "@/components/Inputs/RangePicker/stores/useHoverStore.ts";
import { formatCurrency } from "@/helpers/formatCurrency.ts";
import { memo } from "react";
import { type DayButtonProps } from "react-day-picker";

const formatDayKey = (date: Date): string =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(
    2,
    "0",
  )}`;

export const DayButton = memo((props: DayButtonProps) => {
  const setHoveredDate = useHoverStore((state) => state.setHoveredDate);
  const dayPrices = useDayPriceStore((state) => state.dayPrices);
  const lowPriceThreshold = useDayPriceStore((state) => state.lowPriceThreshold);
  const averagePrice = useDayPriceStore((state) => state.averagePrice);
  const isPricesLoading = useDayPriceStore((state) => state.isPricesLoading);
  const { day, modifiers, children, ...buttonProps } = props;

  const isSelectableDay = !modifiers.outside && !modifiers.disabled;
  const price = dayPrices[formatDayKey(day.date)];
  const showSkeleton = isSelectableDay && isPricesLoading;
  const showPrice = isSelectableDay && !isPricesLoading && price != null;
  const isLowPrice =
    showPrice &&
    lowPriceThreshold != null &&
    averagePrice != null &&
    price <= lowPriceThreshold &&
    price < averagePrice;

  return (
    <button onMouseEnter={() => setHoveredDate(day.date)} {...buttonProps}>
      <span className="rdp-day__number">{children}</span>
      {showSkeleton && <span className="rdp-day__price-skeleton" aria-hidden="true" />}
      {showPrice && (
        <span className={`rdp-day__price${isLowPrice ? " rdp-day__price--low" : ""}`}>
          {formatCurrency(price, "EUR", 0, 0)}
        </span>
      )}
    </button>
  );
});

DayButton.displayName = "DayButton";
